<div class="layout-menu-profile">
  <button
    class="p-link"
    (click)="toggleMenu()"
    pTooltip="Profile"
    [tooltipDisabled]="isTooltipDisabled"
  >
    <img
      src="assets/images/avatarDefault.png"
      alt="avatar"
      style="width: 32px; height: 32px; border-radius: 50%"
    />
    <span>
      <strong> {{ authStore.currentUser()?.firstname }} {{ authStore.currentUser()?.lastname }} </strong>
      <small> {{ authStore.currentUser()?.email }} </small>
    </span>
    <i
      class="layout-menu-profile-toggler pi pi-fw"
      [ngClass]="{
        'pi-angle-down': menuProfilePosition === 'start' || isHorizontal,
        'pi-angle-up': menuProfilePosition === 'end' && !isHorizontal,
      }"
    ></i>
  </button>

  @if (menuProfileActive) {
    <ul [@menu]="isHorizontal ? 'overlay' : 'inline'">
      <li>
        <button
          class="p-link"
          (click)="showConfigSidebar()"
        >
          <i class="pi pi-cog pi-fw"></i>
          <span>Config</span>
        </button>
      </li>
      <li
        pTooltip="Logout"
        [tooltipDisabled]="isTooltipDisabled"
      >
        <button
          class="p-link"
          (click)="logOut()"
        >
          <i class="pi pi-power-off pi-fw"></i>
          <span>Logout</span>
        </button>
      </li>
    </ul>
  }
</div>
